const imageUrl = [
  {
    id: 1,
    name: "milonga",
    src: "https://res.cloudinary.com/dklijqv8g/image/upload/v1629912351/oie_bbcrmGb2XTWF_osfxdu.jpg",
  },
  {
    id: 2,
    name: "class",
    src: "https://res.cloudinary.com/dklijqv8g/image/upload/v1629217891/class_q2cw1u.jpg",
  },
  {
    id: 3,
    name: "radio",
    src: "https://res.cloudinary.com/dklijqv8g/image/upload/v1629911957/oie_TNzEVUWyXqHt_seikic.jpg",
  },
];

module.exports = {
  imageUrl,
};
